import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { kStepCircleSize, TIMED_OUT, TOKENS } from '../constants';

export const ProgressConnector = memo(
  ({ active, timedOut }: { active: boolean; timedOut?: boolean }) => {
    const { rpx } = useResponsiveContext();
    const inactiveColor = timedOut
      ? TIMED_OUT.connectorInactive
      : TOKENS.connectorInactive;
    return (
      <View
        css={`
          flex: 1;
          height: ${rpx(2)}px;
          margin: ${rpx((kStepCircleSize - 2) / 2)}px ${rpx(8)}px 0;
          background-color: ${active ? TOKENS.connectorActive : inactiveColor};
        `}
      />
    );
  },
);
